export enum ResourceTypeEnum {
  Rooms = 0,
  Equipments = 1,
  Misc = 2,
  Desks = 3,
}
